import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
  faCloudSun,
  faMoon,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader, SyncLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import {
  RESET_PERSONALISE_ANALYSIS,
  RESET_PERSONALISE_MCQ_ANSWER,
  RESET_PERSONALISE_QUESTIONS,
  SET_CUSTOM_SKILL_SELECTED,
  SET_ONBOARDING_SELECTED_SKILL,
  SET_PERSONALISE_COURSE_NAME,
} from "../../../redux/actions/types";
import Constants from "../../../common/constants";
import {
  checkUserAccess,
  setOnboardingData,
} from "../../../redux/actions/authentication";
import { getAllSkills } from "../../../redux/actions/skills";
import {
  getGoalsAndRoles,
  onboardingSearch,
} from "../../../redux/actions/userActivity";
import { getAllCourses } from "../../../redux/actions/courses";
import { useDebounce } from "../../../hooks/useDebounce";
import useWindowSize from "../../../hooks/useWindowSize";
import { fetchIsUserFromBetaProduct } from "../../../redux/actions/personaliseCourse";
import ProgressBar from "../../ContentPlayerPage/Quiz/ProgressBar";
import SearchBar from "../../OnboardingRevampPage/SearchBar";
import Skeleton from "../../OnboardingRevampPage/Skeleton";
import SingleList from "../../OnboardingRevampPage/SingleList";
import { Mixpanel } from "../../../config/Mixpanel";

const ExploreCourses = ({ step, setStep, handleSetStep }) => {
  const userName = useSelector((store) => store?.profileDetails?.name);
  const customisedSkill = useSelector(
    (state) => state.personaliseCourse?.customSkillSelected,
  );
  const email = useSelector((store) => store?.profileDetails?.email);
  const betaProductUser = useSelector(
    (store) => store?.personaliseCourse?.betaUsers,
  );
  const [searchValue, setSearchValue] = useState("");
  const [allCourses, setAllCourses] = useState([]);
  const [searchedResults, setSearchedResults] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [isOnBoarded, setIsOnBoarded] = useState(false);
  const [goalClicked, setGoalClicked] = useState(false);
  const [goalIndex, setGoalIndex] = useState(0);
  const [roleClicked, setRoleClicked] = useState(false);
  const [roleIndex, setRoleIndex] = useState(0);
  const [skillClicked, setSkillClicked] = useState(false);
  const [onBoardingSkillLoading, setOnBoardingSkillLoading] = useState(false);
  const [skillName, setSkillName] = useState("");
  const [roles, setRoles] = useState([]);
  const [goals, setGoals] = useState([]);
  const [userInterests, setUserInterests] = useState({
    courseName: "",
    skillDetails: {},
    goal: "",
    role: "",
    timing: "",
  });
  const [customSkillSelected, setCustomSkillSelected] = useState(false);
  const [selectedFromCoursePage, setSelectedFromCoursePage] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const debouncedValue = useDebounce(searchValue, 300);
  const { width } = useWindowSize();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE, {
      distinct_id: email,
    });
    setIsLoading(true);
    dispatch(
      getAllCourses((res) => {
        setAllCourses(res);
        setIsLoading(false);
      }),
    );

    dispatch({ type: RESET_PERSONALISE_QUESTIONS, payload: null });
    dispatch({ type: RESET_PERSONALISE_ANALYSIS, payload: null });
    dispatch({ type: RESET_PERSONALISE_MCQ_ANSWER, payload: null });
    dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: false });
    dispatch(fetchIsUserFromBetaProduct());
    dispatch(
      checkUserAccess((successObj) => {
        setIsOnBoarded(successObj?.is_onboarded);
      }),
    );
    dispatch(
      getGoalsAndRoles(
        (successObj) => {
          const filteredGoals = (successObj?.data).filter(
            (item) => item?.type === "goal",
          );
          const fileredRoles = (successObj?.data).filter(
            (item) => item?.type === "role",
          );

          setRoles(fileredRoles);
          setGoals(filteredGoals);
        },
        (errObj) => {},
      ),
    );
  }, [dispatch, email]);

  useEffect(() => {
    dispatch(
      onboardingSearch(debouncedValue, (successObj) => {
        setSearchedResults(successObj);
      }),
    );
  }, [debouncedValue, dispatch]);

  useEffect(() => {
    if (userInterests?.skillDetails?.["skill-name"]) {
      dispatch({
        type: SET_ONBOARDING_SELECTED_SKILL,
        payload: userInterests?.skillDetails,
      });
    }
  }, [dispatch, userInterests]);
  console.log("userInterests", userInterests);
  const handleDomainSelection = (course_slug, course_name) => {
    Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_COURSE_SELECTED, {
      distinct_id: email,
    });
    setStep((prev) => prev + 1);
    setIsLoading(true);
    setUserInterests({
      ...userInterests,
      courseName: course_name,
    });
    dispatch(
      getAllSkills(course_slug, (result) => {
        setSkillList(result);
        setIsLoading(false);
      }),
    );
  };

  const handleSkillSelection = (id, index) => {
    console.log("skill selction", id);

    Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
      distinct_id: email,
    });
    Mixpanel.track(
      Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_SKILL_CARD_CLICKED,
    );
    setSkillName(id?.["skill-name"]);
    setCustomSkillSelected(false);
    setSkillClicked(true);
    setUserInterests({
      ...userInterests,
      skillDetails: id,
    });
    dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: id });
    handleSetStep(6);

    dispatch({
      type: SET_PERSONALISE_COURSE_NAME,
      payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug },
    });
    setTimeout(() => setSkillClicked(false), 2500);

    if (step === 1) {
      setStep((prev) => prev + 1);
    }
  };

  const handleCustomSkillSelection = () => {
    Mixpanel.track(
      Constants.Mixpanel.NEW_ONBOARDING_PAGE_CUSTOM_SKILL_SELECTED,
      {
        distinct_id: email,
      },
    );
    Mixpanel.track(
      Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_CUSTOM_CARD_CLICKED,
    );
    setCustomSkillSelected(true);
    dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: true });
    dispatch({
      type: SET_PERSONALISE_COURSE_NAME,
      payload: { skill_name: debouncedValue, skill_slug: debouncedValue },
    });
    setUserInterests({
      ...userInterests,
      skillDetails: { id: 0, "skill-name": debouncedValue },
    });
    dispatch({
      type: SET_ONBOARDING_SELECTED_SKILL,
      payload: { id: 0, "skill-name": debouncedValue },
    });
    handleSetStep(6);
    setSearchValue("");
    if (step === 1) {
      setSelectedFromCoursePage(true);
      setStep((prev) => prev + 2);
    } else {
      setSelectedFromCoursePage(false);
      setStep((prev) => prev + 1);
    }
  };

  const handleSearchResult = (id) => {
    setSkillClicked(true);
    setSearchValue("");
    setCustomSkillSelected(false);
    Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
      distinct_id: email,
    });
    Mixpanel.track(
      Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_SKILL_CARD_CLICKED,
    );

    setSkillName(id?.["skill-name"]);
    setUserInterests({
      ...userInterests,
      skillDetails: id,
    });
    dispatch({ type: SET_ONBOARDING_SELECTED_SKILL, payload: id });
    dispatch({
      type: SET_PERSONALISE_COURSE_NAME,
      payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug },
    });
    handleSetStep(6);
    if (step === 1) {
      setSelectedFromCoursePage(true);
      setTimeout(() => setStep((prev) => prev + 2), 2000);
    } else {
      setSelectedFromCoursePage(false);
      setTimeout(() => setStep((prev) => prev + 1), 2000);
    }
    setTimeout(() => setSkillClicked(false), 2500);
  };

  const handleBack = () => {
    if (step === 3 && selectedFromCoursePage) {
      setStep((prev) => prev - 2);
      setSelectedFromCoursePage(false);
    } else {
      setStep((prev) => prev - 1);
    }
  };
  const newLearners = useCallback(() => {
    const time = new Date();
    const hours = time.getHours();
    const minutes = time.getMinutes();
    let maxLearners =
      hours.toString() +
      (minutes <= 9 ? "0" + minutes.toString() : minutes.toString());
    console.log(maxLearners);
    return Math.max(parseInt(maxLearners) + 9, 171);
  }, []);

  return (
    <div className="relative flex w-full flex-col items-center justify-start pb-4 text-white">
      <div
        className="flex w-full cursor-pointer items-center justify-start gap-2 rounded-full text-[20px] font-bold leading-none"
        onClick={handleBack}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        Explore All Courses
      </div>
      <div className="mx-auto mt-6 flex w-full flex-1 flex-col">
        <div className="block">
          <div className="">
            <SearchBar
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setStep={setStep}
              handleCustomSkillSelection={handleCustomSkillSelection}
            />
          </div>
        </div>
        {debouncedValue ? (
          searchedResults?.length > 0 ? (
            <div className="">
              {!skillClicked && (
                <h3 className="mt-2 mb-2 text-lg font-medium ">
                  Select A Course
                </h3>
              )}
              {!skillClicked ? (
                <div className="grid rounded-lg bg-[#406AFF]/10 md:grid-cols-2 md:gap-x-10">
                  {searchedResults?.map((item, index) => (
                    <div
                      key={index}
                      className={`flex items-center py-3 px-4 hover:opacity-70 ${
                        index !== searchedResults?.length - 1
                          ? "border-b-[1px] border-[#70AEFF]/30"
                          : ""
                      } ${
                        userInterests?.skillDetails?.["skill-name"] ===
                        item?.["skill-name"]
                          ? "border-2 border-[#00C838]"
                          : ""
                      } cursor-pointer`}
                      onClick={() => handleSearchResult(item)}
                    >
                      <img
                        src={item?.skill_thumbnail?.lesson_videoThumbnail}
                        width={36}
                        height={20}
                        alt="video thumbnail"
                      />
                      <p className="ml-3 flex-1 text-sm font-semibold">
                        {item?.["skill-name"]}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="mx-auto flex h-[48px] w-full items-center justify-between self-center rounded-lg border-2 border-[#1CB05E] bg-[#2D4F71] px-2 md:w-2/3">
                  <img
                    src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388"
                    width={20}
                    height={20}
                    alt="info icon"
                  />
                  <p className="text-sm font-semibold">
                    <span className="font-bold text-[#00C1FF]">
                      {newLearners()} users
                    </span>{" "}
                    learning {skillName} this week
                  </p>
                  <ClipLoader color="#1CB05E" size={20} />
                </div>
              )}
            </div>
          ) : (
            <>
              <h2 className="mt-2 mb-2 text-lg font-medium ">
                Select Your Course
              </h2>
              <div
                className="flex w-full cursor-pointer items-center rounded-lg bg-[#406AFF]/10 py-3 px-4 md:w-1/2"
                onClick={() => handleCustomSkillSelection()}
              >
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618"
                  width={24}
                  height={24}
                  alt="brain icon"
                />
                <p className="ml-2">{debouncedValue}</p>
              </div>
            </>
          )
        ) : step === 1 ? (
          <div className="">
            {isLoading ? (
              <Skeleton />
            ) : (
              <div>
                {!skillClicked && (
                  <h3 className="mt-2 mb-2 flex items-center justify-between text-lg font-medium">
                    <div>Select A Category</div>
                    <div className="flex items-center justify-end gap-1 text-[12px] text-white/80">
                      <div className="h-2 w-[68px] overflow-hidden rounded-full bg-gray-300">
                        <div
                          className="h-full rounded-full bg-[#2BBD13] transition-all duration-300"
                          style={{ width: `${50}%` }}
                        ></div>
                      </div>
                      Step 1/2
                    </div>
                  </h3>
                )}
                {!skillClicked ? (
                  <div className="grid md:grid-cols-2 md:gap-x-4">
                    {allCourses?.map((item, index) => (
                      <SingleList
                        key={index}
                        name={item?.["course-name"]}
                        step={step}
                        slug={item?.course_slug}
                        imageLink={item?.course_icon?.url}
                        handleDomainSelection={handleDomainSelection}
                        selected={userInterests?.courseName}
                        index={index}
                        lastIndex={allCourses?.length - 1}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="mx-auto flex h-[48px] w-full items-center justify-between self-center rounded-lg border-2 border-[#1CB05E] bg-[#2D4F71] px-2 md:w-2/3">
                    <img
                      src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388"
                      width={20}
                      height={20}
                      alt="info icon"
                    />
                    <p className="text-sm font-semibold">
                      <span className="font-bold text-[#00C1FF]">
                        {newLearners()} users
                      </span>{" "}
                      learning {skillName} this week
                    </p>
                    <ClipLoader color="#1CB05E" size={20} />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : step === 2 ? (
          <div>
            {isLoading ? (
              <Skeleton />
            ) : (
              <div>
                {!skillClicked && (
                  <h3 className="mt-2 mb-2 flex items-center justify-between text-lg font-medium">
                    <div>Select A Category</div>
                    <div className="flex items-center justify-end gap-1 text-[12px] text-white/80">
                      <div className="h-2 w-[68px] overflow-hidden rounded-full bg-gray-300">
                        <div
                          className="h-full rounded-full bg-[#2BBD13] transition-all duration-300"
                          style={{ width: `${100}%` }}
                        ></div>
                      </div>
                      Step 2/2
                    </div>
                  </h3>
                )}
                {!skillClicked ? (
                  <div className="grid md:grid-cols-2 md:gap-x-4 ">
                    {skillList?.map((item, index) => (
                      <SingleList
                        key={index}
                        name={item?.["skill-name"]}
                        step={step}
                        slug={item}
                        imageLink={item?.skill_thumbnail}
                        handleDomainSelection={handleSkillSelection}
                        selected={userInterests?.skillDetails?.["skill-name"]}
                        index={index}
                        lastIndex={skillList?.length - 1}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="mx-auto flex h-[48px] w-full items-center justify-between self-center rounded-lg border-2 border-[#1CB05E] bg-[#2D4F71] px-2 md:w-2/3">
                    <img
                      src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388"
                      width={20}
                      height={20}
                      alt="info icon"
                    />
                    <p className="ml-0.5 text-sm font-semibold">
                      <span className="font-bold text-[#00C1FF]">
                        {newLearners()} users
                      </span>{" "}
                      learning {skillName} this week
                    </p>
                    <ClipLoader color="#1CB05E" size={20} />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ExploreCourses;
